 

import React, { useEffect } from 'react';
import ProBg from "./proBg.jpg"
const DeformedBars = () => {
    useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when this page loads
  }, []);
  return (
    <div>
      <section
        className="featured-job-area section-padding30 section-bg2"
        style={{
         backgroundImage: `url(${ProBg})`, backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',  // Adjust the height here
        }}
      >
        <div className="container">
          <div className="row justify-content">
            <div className="col-xl-7 col-lg-9 col-md-10 col-sm-12">
              {/* Section Title */}
              <div className="section-tittle text-left mb-80">
                <h2>MS Deformed Bars </h2>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {/* Add content here */}
          </div>
        </div>
      </section>

      <section className="about-low-area section-padding2" style={{ marginTop: '-50px' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-10">
              <div className="about-caption mb-11">
                <div className="section-tittle mb-11">
                  {/* <span>About Al Hadeed Steel</span> */}
                  {/* <h2>Building the Future with Strength and Durability</h2> */}
                </div>
  <p style={{lineHeight:"2.4"}}>
  <h3>Deformed Steel Bars (Rebars)</h3>

  <p>Deformed steel bars are rods of steel that are designed with lugs, ribs, or other surface deformations. These modifications reduce slippage within concrete and enhance the bond between the two materials, thereby improving the overall strength and performance of reinforced concrete. Deformed bars have a higher tensile strength than mild steel plain bars, making them ideal for structural applications where strength is paramount.</p>

  <p>These bars are often used without the need for end hooks, and the deformations are spaced uniformly along the length of the bar. This uniformity ensures that the bond between the steel and concrete remains consistent, providing better support under load.</p>

  <p>To prevent cracks that may form in reinforced concrete due to the stretching of bars and the subsequent loss of bond under load, deformed bars are commonly used. These bars typically feature projecting ribs or are twisted, which helps to improve the bond between the steel and the concrete. Deformed bars are available in diameters ranging from 6 mm to 50 mm.</p>

  <p>The strength of the bond created by deformed bars is calculated to be 40% to 80% higher than that of plain round bars of the same nominal size. Moreover, they provide more tensile stress than plain round bars, making them stronger and more durable for construction projects.</p>

  <p>Cold twisted deformed bars (also known as Ribbed or Tor Steel Bars) are recommended by structural engineers as the highest quality steel bars for construction work. These bars undergo a special manufacturing process that improves their surface characteristics and enhances their bond with concrete.</p>

  <h3>High Yield Deformed Bars (HYSD or High Tensile Steel Bars)</h3>

  <p>High Yield Deformed Bars, also known as High Tensile Deformed Bars (HYSD), are another type of deformed steel bar. These bars feature ribs, deformations, or lugs on their surface, which increase the bond strength with concrete. They contain higher carbon content, typically ranging from 0.5% to 1.5%, which contributes to their higher tensile strength. However, this also makes them more brittle, meaning they cannot be bent or reshaped as easily as mild steel bars.</p>

  <p>These bars are primarily used in reinforced concrete (RCC) structures. Their primary purpose is to:</p>
  <ul>
    <li><strong>Reduce slipping</strong> in concrete, ensuring better anchorage.</li>
    <li><strong>Increase the bond strength</strong> between concrete and the steel reinforcement.</li>
    <li><strong>Limit the formation of cracks</strong> in concrete due to the stretching of bars under load.</li>
  </ul>

  <p>The tensile strength of these bars is significantly higher compared to mild steel bars, making them suitable for high-load applications. High Yield Deformed Bars are produced in sizes ranging from 10 mm to 40 mm in diameter and are sold in bundles of 1 tonne each.</p>

  <p>Due to their high carbon content and increased strength, these bars are often used in critical structural elements such as bridges, high-rise buildings, and highways. It is important to note that although they can be bent into required shapes, they must not be bent below a certain minimum radius to avoid cracking or splitting. These bars are commonly referred to as <strong>Reinforcing Bars (REBARS)</strong>.</p>

  <h3>Synonyms and Additional Information:</h3>
  <ul>
    <li><strong>Deformed Bars</strong> are also called <strong>Reinforcement Bars (REBARS)</strong>, <strong>Steel Reinforcing Bars</strong>, or <strong>Rebar Bars</strong>.</li>
    <li><strong>Mild Steel Bars</strong> are also known as <strong>Plain Steel Bars</strong> or <strong>Mild Reinforcement Bars</strong>.</li>
    <li><strong>High Yield Steel Bars</strong> can also be referred to as <strong>High Strength Deformed Bars (HSDB)</strong> or <strong>High Tensile Steel Bars</strong>.</li>
  </ul>

  <p>These steel bars are crucial for ensuring the stability and longevity of concrete structures. Their ability to bond effectively with concrete and resist tensile forces makes them an indispensable material in modern construction.</p>
</p>
      
              </div>
            </div>
          </div>
                
        </div>
      </section>
    </div>
  );
}

export default DeformedBars;
